const getFIO = ({ firstName = '', lastName ='', middleName = '', format = 'FIO' }) => (
  [ ...format ].map((char) => {
    if (char === 'F') {
      return lastName
    }
    if (char === 'I') {
      return firstName
    }
    if (char === 'O') {
      return middleName
    }
  })
    .filter((item) => item)
    .join(' ')
)


export default getFIO